export const loadLocale = async (locale: string): Promise<{}> => {
  try {
    const timestamp = Date.now();
    const response = await fetch(`/assets/locales/${locale}.json?v=${timestamp}`);
    const locales = await response.json();
    return locales;
  } catch (e) {
    console.warn(e);
    return {};
  }
};
